import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  productNameWrapper: {
    backgroundColor: theme.palette.text.white,
    borderRadius: theme.spacing(1),
  },
  activityLogWidth: { width: '30%', height: '254px' },
  rootContainer: {
    display: 'flex',
    padding: theme.spacing(4),
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    borderRadius: theme.spacing(1),
    background: theme.palette.text.white,
    boxSizing: 'border-box',
  },
  titleIconContainer: {
    display: 'flex',
    height: theme.spacing(3.5),
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    backgroundColor: theme.palette.textBackground.main,
    borderRadius: theme.spacing(0.5),
  },
  titleIcon: {
    color: theme.palette.labraText.primary,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 500,
    padding: theme.spacing(0, 1),
  },
  headingContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
  heading: {
    fontSize: theme.typography.pxToRem(16),
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: theme.typography.pxToRem(24),
    color: theme.palette.labraText.primary,
    fontFamily: theme.typography.fontFamily,
    letterSpacing: '0.15',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  svgBackground: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    opacity: 0.1,
  },
  labraIcon: {
    height: theme.spacing(10.5),
    width: theme.spacing(11),
  },
}))
